// extracted by mini-css-extract-plugin
export default {"label":"l0po2","value":"eirZX"};